import { styled } from "@mui/material"
import { Link } from "react-router-dom"

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px  0 24px 96px  ',
    [theme.breakpoints.down('md')]: {
        padding: '24px 0 24px 48px '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px  '
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px  '
    }
}))
export const Heading = styled('h4')(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    lineHeight: "29px",
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
export const ContentSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '16px',
    overflowY: 'hidden',
    overflowX: 'auto',
    padding: '24px 0 '
}))
export const Card = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '288px',
    minWidth: '288px',
    maxHeight: '403px',
    height: '403px',
    borderRadius: theme.shape.bigBorderRadios,
    border: props.loading ? "none" : '1px solid #0056D280',
    background: props.loading ? theme.palette.mode === "light" ?
        theme.palette.background.lightSecondary : theme.palette.background.darkSecondary : "transparent"
}))
export const CardBlueTop = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    height: '72px',
    background: '#0056D21A',
}))
export const CardContent = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    flex: '1',
    position: 'relative',
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '0 0 0 0',
}))
export const CardImg = styled('div')(({ theme }) => (props) => ({
    width: '200px',
    height: '200px',
    position: 'absolute',
    top: '-48px',
    alignSelf: 'center'
}))
export const Img = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: '50%'
}))
export const TitleCard = styled('h5')(({ theme }) => (props) => ({
    fontSize: "20px",
    fontWeight: '700',
    lineHeight: '24px',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    margin: '0'
}))
export const TitleCardSecondary = styled('h6')(({ theme }) => (props) => ({
    fontSize: "14px",
    fontWeight: '400',
    lineHeight: '17px',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center '
}))
export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '1.5vw',
    letterSpacing: '0em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw'

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    }
}))
export const Tit = styled('div')(({ theme }) => (props) => ({
    width: '80%',
}))
export const TitleDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "20px",
    padding: ' 0  16px ',
    textAlign: 'center',
}))
export const TitLink = styled(Link)(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.primary.main
}))